import { ShippingProviderCardSimplifiedShell } from './ShippingProviderCardSimplifiedShell';

export const ShippingProviderCardSimplifiedSkeleton: React.FC = () => {
    return (
        <ShippingProviderCardSimplifiedShell>
            <div className="skeleton-block size-10 shrink-0 rounded-lg" />
            <div className="skeleton-block h-4 w-3/5 rounded-sm" />
        </ShippingProviderCardSimplifiedShell>
    );
};
